<fs-dialog>
  <div class="fs-row.justify-end">
    <button mat-icon-button mat-dialog-close aria-label="Close" type="button" tabindex="-1">
      <mat-icon>clear</mat-icon>
    </button>
  </div>
  <mat-card>
    <app-organization-name
      *ngIf="step === 0"
      [(environmentCreate)]="environmentCreate"
      (environmentCreateChange)="stepNext()"
    ></app-organization-name>
    <app-address
      *ngIf="step === 1"
      [(environmentCreate)]="environmentCreate"
      (environmentCreateChange)="stepNext()"
    ></app-address>
    <app-contact-info
      *ngIf="step === 2"
      [environmentCreate]="environmentCreate"
      (environmentCreateChange)="stepNext()"
    ></app-contact-info>
    <app-diseases
      *ngIf="step === 3"
      [environmentCreate]="environmentCreate"
      (completed)="close()"
    ></app-diseases>
    <!-- <app-invite
      *ngIf="step === 4"
      [environmentCreate]="environmentCreate"
      (completed)="close()"
      (cancel)="close()"
    ></app-invite> -->
    <app-progress
      [step]="step"
    ></app-progress>
  </mat-card>
</fs-dialog>
